/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { ListingStatus } from '@zcode/enums'
import type { Listing } from '@zcode/state-type'

export type GetListingWinnerPartialListing = Partial<
  Pick<Listing, 'listedOn' | 'listingStatus' | 'promotion'>
>

const getListingStatusWeight = (listingStatus: number) => {
  if (listingStatus === ListingStatus.ACTIVE) {
    return 3
  }
  if (listingStatus === ListingStatus.FOR_SALE) {
    return 2
  }
  if (listingStatus === ListingStatus.PRIVATE) {
    return 1
  }
  return 0
}

const compareListings = (a: GetListingWinnerPartialListing, b: GetListingWinnerPartialListing) => {
  if ((a.listingStatus || b.listingStatus) && a.listingStatus !== b.listingStatus) {
    return (
      getListingStatusWeight(b.listingStatus ?? 0) - getListingStatusWeight(a.listingStatus ?? 0)
    )
  }
  if ((a.promotion || b.promotion) && a.promotion !== b.promotion) {
    return (b.promotion ?? 0) - (a.promotion ?? 0)
  }
  return (b.listedOn ?? 0) - (a.listedOn ?? 0)
}

export const getListingWinner = <T extends GetListingWinnerPartialListing>(
  listings: readonly T[]
) => {
  const sorted = [...listings]?.sort(compareListings)
  return sorted?.[0]
}
